var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelRenewalV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 235,
    viewBox: "0 0 314 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314 206.514H0V206.671H314V206.514Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.864 214.752H252.035V214.91H269.864V214.752Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.432 214.828H231.5V214.986H247.432V214.828Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.718 211.176H152.271V211.333H173.718V211.176Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.16 216.064H184.355V216.222H214.16V216.064Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7043 210.992H60.8477V211.15H89.7043V210.992Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.993 210.992H93.1895V211.15H102.993V210.992Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4765 213.832H39.2246V213.99H64.4765V213.832Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.836 178.382H27.5757C26.6257 178.38 25.7153 178 25.0442 177.325C24.373 176.65 23.9961 175.734 23.9961 174.78V3.57016C24.0044 2.6215 24.3849 1.71442 25.0552 1.04596C25.7254 0.377491 26.6312 0.00162511 27.5757 0L148.836 0C149.787 0 150.699 0.379464 151.372 1.05491C152.044 1.73036 152.422 2.64647 152.422 3.6017V174.78C152.422 175.736 152.044 176.652 151.372 177.327C150.699 178.003 149.787 178.382 148.836 178.382ZM27.5757 0.126154C26.6674 0.127825 25.7969 0.491413 25.1552 1.13711C24.5135 1.7828 24.1531 2.65785 24.1531 3.57016V174.78C24.1531 175.693 24.5135 176.568 25.1552 177.213C25.7969 177.859 26.6674 178.223 27.5757 178.224H148.836C149.745 178.221 150.615 177.857 151.257 177.212C151.899 176.567 152.262 175.693 152.265 174.78V3.57016C152.262 2.65778 151.899 1.78371 151.257 1.13855C150.615 0.493395 149.745 0.129478 148.836 0.126154H27.5757Z",
    fill: "#E0E0E0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M284.679 178.382H163.412C162.462 178.379 161.552 177.998 160.88 177.323C160.208 176.649 159.829 175.735 159.826 174.78V3.57016C159.836 2.62092 160.218 1.71385 160.889 1.04556C161.561 0.37727 162.467 0.00160739 163.412 0L284.679 0C285.622 0.00328284 286.526 0.379881 287.195 1.04817C287.864 1.71646 288.244 2.62259 288.252 3.57016V174.78C288.253 175.252 288.161 175.72 287.982 176.157C287.803 176.593 287.54 176.99 287.208 177.324C286.876 177.659 286.482 177.924 286.048 178.106C285.614 178.287 285.149 178.381 284.679 178.382ZM163.412 0.126154C162.504 0.129478 161.633 0.493395 160.991 1.13855C160.349 1.78371 159.986 2.65778 159.983 3.57016V174.78C159.986 175.693 160.349 176.567 160.991 177.212C161.633 177.857 162.504 178.221 163.412 178.224H284.679C285.587 178.221 286.457 177.857 287.1 177.212C287.742 176.567 288.104 175.693 288.108 174.78V3.57016C288.104 2.65778 287.742 1.78371 287.1 1.13855C286.457 0.493395 285.587 0.129478 284.679 0.126154H163.412Z",
    fill: "#E0E0E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M206.21 15.3086H44.8145V97.0313H206.21V15.3086Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.314 15.3086H46.918V97.0313H208.314V15.3086Z",
    fill: "#EFEFEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.54 19.1367H50.6992V93.1892H204.54V19.1367Z",
    fill: "#F4F4F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0898 93.197L103.814 19.1445H123.364L81.6458 93.197H62.0898Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.209 93.197L129.933 19.1445H149.483L107.765 93.197H88.209Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.557 93.197L184.275 19.1445H192.326L150.608 93.197H142.557Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.457 19.1367H148.768V93.1892H154.457V19.1367Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.27 19.1367H96.5801V93.1892H102.27V19.1367Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.453 16.293H150.764V95.6313H156.453V16.293Z",
    fill: "#F4F4F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.268 16.293H98.5781V95.6313H104.268V16.293Z",
    fill: "#F4F4F4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M204.54 19.1367H202.951V93.1892H204.54V19.1367Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M246.076 121.158C246.076 121.158 234.559 101.22 250.535 85.3496C250.535 85.3496 254.705 88.0745 254.642 91.7456C254.579 95.4167 250.177 96.3439 251.119 99.4095C252.061 102.475 256.225 105.478 253.499 108.007C250.774 110.536 253.932 112.794 253.75 115.892C253.568 118.989 246.076 121.158 246.076 121.158Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.884 124.419C247.884 124.419 252.55 101.85 232.404 91.8457C232.404 91.8457 229.308 95.7565 230.52 99.2194C231.732 102.682 236.203 102.171 236.266 105.376C236.329 108.58 233.327 112.749 236.712 114.289C240.097 115.828 237.798 118.969 238.947 121.858C240.097 124.747 247.884 124.419 247.884 124.419Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.629 118.686C237.629 118.686 237.83 128.097 245.579 128.097C253.329 128.097 253.536 118.686 253.536 118.686H237.629Z",
    fill: "#F4F4F4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.854 120.768C183.854 120.768 184.117 128.097 194.31 128.097C204.502 128.097 204.772 120.768 204.772 120.768H183.854Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M207.51 122.584C207.51 122.584 207.711 128.097 215.372 128.097C223.034 128.097 223.229 122.584 223.229 122.584H207.51Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.032 132.67H173.875V201.783H191.032V132.67Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.77 201.777H177.166V206.514H261.77V201.777Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M265.066 132.664H191.031V201.778H265.066V132.664Z",
    fill: "#F4F4F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M258.321 139.35H197.775V163.861H258.321V139.35Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M258.321 168.328H197.775V192.84H258.321V168.328Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M234.872 142.038H221.251C220.807 142.038 220.382 141.861 220.068 141.547C219.753 141.232 219.576 140.806 219.574 140.36C219.578 139.914 219.755 139.488 220.069 139.173C220.383 138.858 220.807 138.679 221.251 138.676H234.872C235.316 138.679 235.741 138.858 236.054 139.173C236.368 139.488 236.546 139.914 236.549 140.36C236.547 140.806 236.37 141.232 236.056 141.547C235.741 141.861 235.316 142.038 234.872 142.038Z",
    fill: "#F4F4F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M234.872 171.014H221.251C220.807 171.014 220.382 170.838 220.068 170.523C219.753 170.209 219.576 169.782 219.574 169.336C219.578 168.891 219.755 168.464 220.069 168.149C220.383 167.834 220.807 167.656 221.251 167.652H234.872C235.316 167.656 235.741 167.834 236.054 168.149C236.368 168.464 236.546 168.891 236.549 169.336C236.547 169.782 236.37 170.209 236.056 170.523C235.741 170.838 235.316 171.014 234.872 171.014Z",
    fill: "#F4F4F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M267.346 128.098H191.025V132.671H267.346V128.098Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M191.025 128.09H171.469V132.663H191.025V128.09Z",
    fill: "#E0E0E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M263.521 26.8145H226.355V69.8204H263.521V26.8145Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M267.742 26.8145H227.469V69.8204H267.742V26.8145Z",
    fill: "#F4F4F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M264.369 30.2012H230.84V66.4263H264.369V30.2012Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M253.285 38.9824H241.925C240.291 38.9824 238.967 40.3126 238.967 41.9534V54.676C238.967 56.3168 240.291 57.6469 241.925 57.6469H253.285C254.919 57.6469 256.243 56.3168 256.243 54.676V41.9534C256.243 40.3126 254.919 38.9824 253.285 38.9824Z",
    fill: "#F4F4F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.988 166.473H164.674V206.514H168.988V166.473Z",
    fill: "#E0E0E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M168.988 166.473H166.828V206.514H168.988V166.473Z",
    fill: "#F4F4F4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.092 177.689H147.127C147.452 177.413 147.713 177.069 147.892 176.681C148.071 176.293 148.164 175.871 148.164 175.443H113.04C113.04 175.871 113.134 176.294 113.314 176.682C113.494 177.07 113.756 177.413 114.082 177.689H111.156C110.106 177.689 109.1 178.108 108.358 178.853C107.616 179.598 107.199 180.609 107.199 181.663V193.25C107.199 194.304 107.616 195.315 108.358 196.06C109.1 196.805 110.106 197.224 111.156 197.224H150.092C151.141 197.224 152.147 196.805 152.889 196.06C153.631 195.315 154.048 194.304 154.048 193.25V181.663C154.048 180.609 153.631 179.598 152.889 178.853C152.147 178.108 151.141 177.689 150.092 177.689Z",
    fill: "#F4F4F4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.606 186.248H93.9869C92.5164 186.248 91.3242 187.445 91.3242 188.923V194.549C91.3242 196.026 92.5164 197.223 93.9869 197.223H117.606C119.077 197.223 120.269 196.026 120.269 194.549V188.923C120.269 187.445 119.077 186.248 117.606 186.248Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M119.377 183.826H92.216C91.7235 183.826 91.3242 184.227 91.3242 184.722V185.744C91.3242 186.238 91.7235 186.639 92.216 186.639H119.377C119.869 186.639 120.269 186.238 120.269 185.744V184.722C120.269 184.227 119.869 183.826 119.377 183.826Z",
    fill: "#E0E0E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M122.938 148.59C122.938 148.59 123.346 161.836 138.794 161.836C154.243 161.836 154.651 148.59 154.651 148.59H122.938Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6928 161.844H48.4258V166.474H67.6928V161.844Z",
    fill: "#E0E0E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M183.942 161.844H67.6992V166.474H183.942V161.844Z",
    fill: "#F4F4F4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6928 197.223H48.4258V201.853H67.6928V197.223Z",
    fill: "#E0E0E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.746 166.473H48.4316V206.514H52.746V166.473Z",
    fill: "#E0E0E0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.7463 166.473H50.5859V206.514H52.7463V166.473Z",
    fill: "#F4F4F4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8515 166.473H65.5371V206.514H69.8515V166.473Z",
    fill: "#F4F4F4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6974 166.473H65.5371V206.514H67.6974V166.473Z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M183.935 166.473H179.621V206.514H183.935V166.473Z",
    fill: "#F4F4F4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M181.781 166.473H179.621V206.514H181.781V166.473Z",
    fill: "#E0E0E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M183.942 197.223H67.6992V201.853H183.942V197.223Z",
    fill: "#F4F4F4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6967 159.111H75.2598V161.843H98.6967V159.111Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M107.094 159.105H98.6973V161.837H107.094V159.105Z",
    fill: "#EBEBEB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M156.999 234.999C224.247 234.999 278.762 231.803 278.762 227.859C278.762 223.916 224.247 220.719 156.999 220.719C89.7514 220.719 35.2363 223.916 35.2363 227.859C35.2363 231.803 89.7514 234.999 156.999 234.999Z",
    fill: "#F5F5F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136.824 60.3637C136.868 67.8383 131.536 67.7626 131.643 65.4098C131.749 63.0571 130.431 57.5315 131.643 58.0677C132.855 58.6038 136.805 57.0584 136.824 60.3637Z",
    fill: "#1A2E35"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M133.469 73.8997C134.204 73.8429 135.68 74.5305 135.812 76.4796C135.846 77.0459 136.011 77.5965 136.293 78.0879C136.575 78.5794 136.967 78.9983 137.438 79.3117C137.438 79.3117 134.995 79.6082 133.394 78.334C132.088 77.3059 131.51 75.054 132.194 74.5494C132.57 74.2471 133.004 74.026 133.469 73.8997Z",
    fill: "#1A2E35"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.509 68.5898C133.765 69.7063 134.914 72.6583 132.082 74.0586C129.249 75.4589 124.797 72.1663 124.797 72.1663L129.689 69.8892L132.509 68.5898Z",
    fill: "#1A2E35"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M133.903 74.171C133.835 73.7622 133.721 73.3624 133.564 72.9788C133.552 72.9469 133.534 72.9176 133.511 72.8927C133.488 72.8677 133.46 72.8476 133.429 72.8336C133.398 72.8195 133.365 72.8117 133.331 72.8107C133.297 72.8096 133.263 72.8153 133.231 72.8275H133.181L131.442 73.9944C131.414 74.0134 131.389 74.0378 131.371 74.0662C131.352 74.0946 131.339 74.1264 131.333 74.1598C131.326 74.1932 131.327 74.2275 131.333 74.2608C131.34 74.2941 131.354 74.3258 131.373 74.3539C131.392 74.3801 131.416 74.4035 131.442 74.4233C131.693 74.6066 131.962 74.763 132.245 74.8901C132.654 75.0541 133.501 74.5873 133.79 74.3855C133.826 74.363 133.856 74.3314 133.876 74.2937C133.896 74.256 133.905 74.2136 133.903 74.171Z",
    fill: "url(#paint0_linear_8517_16365)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.903 74.171C133.835 73.7622 133.721 73.3624 133.564 72.9788C133.552 72.9469 133.534 72.9176 133.511 72.8927C133.488 72.8677 133.46 72.8476 133.429 72.8336C133.398 72.8195 133.365 72.8117 133.331 72.8107C133.297 72.8096 133.263 72.8153 133.231 72.8275H133.181L131.442 73.9944C131.414 74.0134 131.389 74.0378 131.371 74.0662C131.352 74.0946 131.339 74.1264 131.333 74.1598C131.326 74.1932 131.327 74.2275 131.333 74.2608C131.34 74.2941 131.354 74.3258 131.373 74.3539C131.392 74.3801 131.416 74.4035 131.442 74.4233C131.693 74.6066 131.962 74.763 132.245 74.8901C132.654 75.0541 133.501 74.5873 133.79 74.3855C133.826 74.363 133.856 74.3314 133.876 74.2937C133.896 74.256 133.905 74.2136 133.903 74.171Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M115.182 71.0747C114.484 70.8413 112.889 71.1567 112.299 73.0237C112.131 73.5653 111.841 74.0605 111.451 74.4708C111.061 74.881 110.582 75.1953 110.051 75.3891C110.051 75.3891 112.356 76.2596 114.214 75.3891C115.722 74.7016 116.789 72.6453 116.268 71.9893C115.973 71.6122 115.603 71.3008 115.182 71.0747Z",
    fill: "#1A2E35"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M122.102 58.2383C119.559 58.9321 116.136 61.9598 117.656 65.6751C116.155 66.7032 114.233 69.6615 116.482 71.5539C118.899 73.5912 124.847 70.7339 124.847 70.7339L124.89 69.7625L125.6 62.5338L122.102 58.2383Z",
    fill: "#1A2E35"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.699 71.2383C114.866 70.8557 115.077 70.4937 115.327 70.1597C115.371 70.1054 115.435 70.071 115.505 70.0639C115.574 70.0568 115.643 70.0776 115.698 70.1218L115.735 70.1597L117.142 71.7051C117.166 71.7291 117.185 71.7576 117.198 71.789C117.211 71.8204 117.217 71.854 117.217 71.888C117.217 71.922 117.211 71.9556 117.198 71.987C117.185 72.0184 117.166 72.0469 117.142 72.0709C117.122 72.0948 117.096 72.1124 117.067 72.1214C116.781 72.239 116.485 72.3257 116.181 72.38C115.742 72.4431 115.063 71.7934 114.8 71.5285C114.756 71.496 114.722 71.4508 114.704 71.399C114.687 71.3472 114.685 71.2912 114.699 71.2383Z",
    fill: "url(#paint1_linear_8517_16365)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.699 71.2383C114.866 70.8557 115.077 70.4937 115.327 70.1597C115.371 70.1054 115.435 70.071 115.505 70.0639C115.574 70.0568 115.643 70.0776 115.698 70.1218L115.735 70.1597L117.142 71.7051C117.166 71.7291 117.185 71.7576 117.198 71.789C117.211 71.8204 117.217 71.854 117.217 71.888C117.217 71.922 117.211 71.9556 117.198 71.987C117.185 72.0184 117.166 72.0469 117.142 72.0709C117.122 72.0948 117.096 72.1124 117.067 72.1214C116.781 72.239 116.485 72.3257 116.181 72.38C115.742 72.4431 115.063 71.7934 114.8 71.5285C114.756 71.496 114.722 71.4508 114.704 71.399C114.687 71.3472 114.685 71.2912 114.699 71.2383Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.583 84.5664C138.782 85.4999 140.095 86.4966 141.413 87.4049C142.732 88.3132 144.057 89.2278 145.42 90.0667C146.783 90.9056 148.164 91.6878 149.559 92.4321L150.607 92.9683L151.675 93.4666C152.027 93.6369 152.385 93.7883 152.749 93.927L153.283 94.1478C153.465 94.2172 153.659 94.3055 153.772 94.337C154.429 94.5381 155.101 94.6836 155.782 94.7723C156.523 94.8795 157.302 94.9552 158.093 95.012C159.669 95.1129 161.29 95.157 162.916 95.1633C164.543 95.1697 166.188 95.1633 167.827 95.1129L172.757 94.9741L173.065 97.453C169.766 98.1202 166.435 98.615 163.086 98.9354C161.396 99.0867 159.701 99.2003 157.967 99.2129C157.101 99.2129 156.222 99.2129 155.317 99.1309C154.345 99.0744 153.381 98.9159 152.441 98.6578C152.152 98.5821 151.97 98.5064 151.757 98.437L151.129 98.2163C150.708 98.0775 150.293 97.9261 149.873 97.7558L148.654 97.2638L147.461 96.734C145.884 96.0208 144.347 95.2206 142.858 94.337C141.376 93.4603 139.919 92.552 138.512 91.5806C137.076 90.6034 135.692 89.5507 134.367 88.4267L137.583 84.5664Z",
    fill: "#FD897B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M131.064 81.7346C132.628 80.5109 139.065 84.5163 141.024 86.1879L139.599 94.8483C139.599 94.8483 130.336 90.9502 129.777 88.2883C129.199 85.5066 129.884 82.6682 131.064 81.7346Z",
    fill: "#1A2E35"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M172.072 95.1894L175.953 92.168L176.26 96.842C176.26 96.842 173.585 98.5072 171.82 97.4728L172.072 95.1894Z",
    fill: "#FD897B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M179.413 91.707L181.398 93.9273L176.235 96.8415L175.928 92.1675L179.413 91.707Z",
    fill: "#FD897B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M105.68 221.696L110.572 222.062L112.355 210.753L107.469 210.387L105.68 221.696Z",
    fill: "#FD897B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0703 205.89L75.2214 208.514L82.613 199.708L78.4619 197.078L71.0703 205.89Z",
    fill: "#FD897B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5347 207.573L72.6474 203.643C72.5803 203.576 72.4914 203.535 72.3969 203.528C72.3024 203.521 72.2086 203.549 72.1324 203.605L68.5968 206.261C68.4338 206.393 68.3296 206.585 68.3073 206.794C68.2849 207.004 68.3461 207.213 68.4775 207.377L68.534 207.441C69.9093 208.784 70.6441 209.364 72.3522 211.093C73.401 212.159 74.8266 213.818 76.2772 215.287C77.7279 216.757 79.2477 215.388 78.7892 214.657C76.6666 211.332 77.0497 210.09 76.9052 208.399C76.8879 208.087 76.7559 207.793 76.5347 207.573Z",
    fill: "#1A2E35"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M110.899 221.356H105.385C105.288 221.356 105.194 221.39 105.12 221.452C105.045 221.514 104.994 221.601 104.977 221.696L104.104 226.074C104.069 226.266 104.11 226.465 104.22 226.626C104.329 226.788 104.497 226.9 104.688 226.938C104.746 226.944 104.805 226.944 104.864 226.938C106.785 226.938 107.721 226.793 110.145 226.793C111.634 226.793 115.797 226.944 117.876 226.944C119.955 226.944 120.162 224.901 119.314 224.718C115.546 223.885 112.952 222.744 111.715 221.646C111.488 221.452 111.197 221.349 110.899 221.356Z",
    fill: "#1A2E35"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M112.356 210.752L111.364 217.035L106.541 216.221L107.464 210.393L112.356 210.752Z",
    fill: "#E77064"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4631 197.084L82.6142 199.708L79.5558 203.354L75.3105 200.837L78.4631 197.084Z",
    fill: "#E77064"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M109.398 107.943L128.954 111.771C139.059 84.2887 136.861 83.3867 136.861 83.3867C135.44 82.6017 133.972 81.9065 132.465 81.3052L132.201 81.2043C130.945 80.7438 130.694 80.6744 129.023 80.1824C126.147 79.4949 123.466 78.9209 120.144 78.4478L119.516 78.3595C118.888 78.2838 118.316 78.2207 117.738 78.1639C117.349 78.1198 116.96 78.0946 116.589 78.0693L115.333 77.9999C113.185 77.8927 111.647 77.9242 111.647 77.9242C112.243 95.0875 111.276 100.014 109.398 107.943Z",
    fill: "#1A2E35"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M122.969 68.5898C122.969 71.5671 122.511 76.9349 120.137 78.4614C120.137 78.4614 120.357 81.5269 125.663 82.5614C131.504 83.7031 129.017 80.196 129.017 80.196C125.983 78.8083 126.505 76.4492 127.509 74.3299L122.969 68.5898Z",
    fill: "#FD897B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M124.822 70.9297L127.51 74.3295C127.277 74.8219 127.083 75.3324 126.932 75.856C125.745 75.4397 124.332 73.7745 124.42 72.4688C124.458 71.9353 124.595 71.4135 124.822 70.9297Z",
    fill: "#E77064"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M122.686 61.7518C122.058 66.6024 121.675 68.6398 123.609 71.5729C126.517 75.9883 132.583 75.7044 134.649 71.144C136.533 67.0377 137.237 59.7901 132.935 56.9832C132.207 56.5003 131.392 56.1663 130.536 56C129.679 55.8338 128.799 55.8387 127.944 56.0145C127.09 56.1902 126.279 56.5333 125.556 57.0242C124.834 57.5151 124.215 58.1442 123.735 58.8755C123.17 59.7405 122.811 60.7248 122.686 61.7518Z",
    fill: "#FD897B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M138.406 54.0692C138.494 54.8384 138.436 55.6175 138.236 56.3652C138.191 56.1114 138.13 55.8607 138.054 55.6146C136.333 49.8998 128.584 51.2622 126.248 53.7222C122.48 52.6373 118.894 53.5015 119.371 58.1376C119.431 59.3321 119.859 60.4784 120.596 61.4177C120.012 63.045 120.596 65.6375 122.524 65.7132C125.237 65.8204 127.811 62.2124 128.848 60.2318C130.732 60.5535 133.444 60.8626 135.504 60.358C135.85 60.5661 136.132 60.7112 136.132 60.7112C138.324 59.5316 139.995 58.39 138.406 54.0692Z",
    fill: "#1A2E35"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.015 65.0636C120.94 66.0047 121.235 66.9379 121.838 67.6624C122.655 68.6148 123.722 68.0535 124.105 66.9244C124.426 65.9025 124.382 64.1805 123.289 63.6444C123.099 63.5548 122.894 63.5037 122.684 63.4939C122.475 63.4841 122.266 63.5159 122.069 63.5873C121.872 63.6588 121.69 63.7686 121.536 63.9104C121.381 64.0522 121.255 64.2233 121.166 64.4139C121.072 64.6178 121.021 64.8389 121.015 65.0636Z",
    fill: "#FD897B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M128.658 111.771C128.658 111.771 128.734 150.766 125.556 165.45C122.253 180.727 112.538 215.483 112.538 215.483L105.504 214.568C105.504 214.568 111.011 179.459 113.354 164.277C115.91 147.732 114.346 108.971 114.346 108.971L128.658 111.771Z",
    fill: "url(#paint2_linear_8517_16365)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128.658 111.771C128.658 111.771 128.734 150.766 125.556 165.45C122.253 180.727 112.538 215.483 112.538 215.483L105.504 214.568C105.504 214.568 111.011 179.459 113.354 164.277C115.91 147.732 114.346 108.971 114.346 108.971L128.658 111.771Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M113.738 216.095L104.299 214.871L104.701 211.516L115.414 212.777L113.738 216.095Z",
    fill: "#1A2E35"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M123.792 110.763C123.792 110.763 113.26 142.989 108.029 161.553C102.515 181.138 81.3766 202.799 81.3766 202.799L75.3164 199.279C75.3164 199.279 89.7604 178.716 95.067 160.442C105.875 123.347 101.435 115.487 109.398 107.943L123.792 110.763Z",
    fill: "url(#paint3_linear_8517_16365)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.792 110.763C123.792 110.763 113.26 142.989 108.029 161.553C102.515 181.138 81.3766 202.799 81.3766 202.799L75.3164 199.279C75.3164 199.279 89.7604 178.716 95.067 160.442C105.875 123.347 101.435 115.487 109.398 107.943L123.792 110.763Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3629 203.776L73.9414 198.894L76.0389 195.879L85.3898 201.058L82.3629 203.776Z",
    fill: "#1A2E35"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M129.657 64.5079C129.581 64.899 129.726 65.2522 129.983 65.3027C130.241 65.3532 130.504 65.0756 130.611 64.6719C130.718 64.2682 130.542 63.9213 130.285 63.8708C130.027 63.8204 129.732 64.1168 129.657 64.5079Z",
    fill: "#1A2E35"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M134.047 65.3655C133.972 65.7566 134.116 66.1161 134.374 66.1666C134.631 66.217 134.895 65.9395 134.97 65.5358C135.046 65.1321 134.901 64.7852 134.644 64.741C134.386 64.6969 134.123 64.9681 134.047 65.3655Z",
    fill: "#1A2E35"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M134.531 64.748L135.517 64.666C135.517 64.666 134.895 65.3031 134.531 64.748Z",
    fill: "#1A2E35"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M132.76 65.8145C132.934 66.7707 133.238 67.6983 133.665 68.5709C133.44 68.6768 133.194 68.7317 132.946 68.7317C132.697 68.7317 132.452 68.6768 132.227 68.5709L132.76 65.8145Z",
    fill: "#FD5652"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M130.58 69.8329C130.055 69.7466 129.559 69.534 129.134 69.2133C128.708 68.8925 128.366 68.4732 128.137 67.991C128.131 67.9774 128.128 67.9626 128.127 67.9476C128.126 67.9326 128.129 67.9176 128.134 67.9035C128.139 67.8894 128.147 67.8765 128.158 67.8655C128.168 67.8546 128.18 67.8458 128.194 67.8397C128.222 67.829 128.254 67.8295 128.282 67.8412C128.31 67.853 128.332 67.875 128.345 67.9027C128.564 68.3458 128.884 68.7309 129.279 69.0268C129.674 69.3226 130.133 69.521 130.618 69.6058C130.633 69.6081 130.647 69.6134 130.66 69.6213C130.673 69.6293 130.684 69.6397 130.693 69.6521C130.702 69.6644 130.708 69.6784 130.711 69.6932C130.715 69.708 130.715 69.7233 130.712 69.7383C130.706 69.7678 130.689 69.794 130.665 69.8115C130.64 69.8291 130.61 69.8367 130.58 69.8329Z",
    fill: "#1A2E35"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M128.658 62.8303C128.597 62.8272 128.54 62.8017 128.497 62.7585C128.454 62.7154 128.429 62.6578 128.426 62.5969C128.428 62.5326 128.455 62.4716 128.501 62.4266C128.77 62.1726 129.096 61.9868 129.451 61.8847C129.806 61.7827 130.18 61.7674 130.542 61.84C130.602 61.8576 130.652 61.8978 130.682 61.9519C130.713 62.006 130.721 62.0699 130.705 62.1301C130.698 62.1592 130.685 62.1865 130.667 62.2105C130.649 62.2345 130.627 62.2547 130.601 62.2699C130.576 62.2852 130.547 62.2952 130.518 62.2993C130.488 62.3035 130.458 62.3017 130.429 62.2941C130.141 62.2429 129.846 62.2596 129.566 62.3427C129.286 62.4259 129.029 62.5734 128.815 62.7735C128.772 62.8119 128.716 62.8322 128.658 62.8303Z",
    fill: "#1A2E35"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M136.483 63.7072C136.437 63.7077 136.392 63.6942 136.354 63.6682C136.316 63.6423 136.287 63.6053 136.27 63.5621C136.161 63.2919 135.992 63.0506 135.775 62.857C135.558 62.6633 135.3 62.5225 135.02 62.4457C134.99 62.4403 134.961 62.4291 134.935 62.4126C134.91 62.396 134.887 62.3745 134.87 62.3493C134.852 62.3241 134.84 62.2957 134.834 62.2657C134.827 62.2357 134.826 62.2047 134.832 62.1744C134.844 62.1141 134.879 62.0608 134.929 62.0255C134.979 61.9903 135.041 61.9759 135.102 61.9852C135.46 62.0751 135.792 62.2496 136.069 62.4943C136.347 62.7389 136.562 63.0467 136.697 63.3918C136.709 63.42 136.716 63.4503 136.717 63.4811C136.718 63.5119 136.713 63.5426 136.701 63.5713C136.69 63.6001 136.674 63.6263 136.652 63.6485C136.631 63.6708 136.606 63.6886 136.578 63.7009L136.483 63.7072Z",
    fill: "#1A2E35"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M130.184 67.9657C129.99 67.9664 129.798 67.9218 129.624 67.8353C129.449 67.7489 129.297 67.6229 129.18 67.4674C128.884 67.0047 128.687 66.4858 128.601 65.9431C128.514 65.4004 128.54 64.8457 128.677 64.3135C129.035 62.3203 130.279 60.6992 131.453 60.6992C131.648 60.702 131.841 60.7488 132.016 60.8361C132.191 60.9235 132.344 61.0491 132.464 61.2038C132.759 61.6665 132.956 62.1854 133.043 62.7281C133.129 63.2708 133.103 63.8256 132.966 64.3577C132.608 66.3509 131.359 67.9657 130.184 67.9657ZM131.44 60.8758C130.341 60.8758 129.161 62.4401 128.815 64.3577C128.596 65.6192 128.771 66.7546 129.286 67.3665C129.391 67.503 129.525 67.6137 129.678 67.6903C129.832 67.7668 130 67.8071 130.172 67.808C131.277 67.808 132.451 66.25 132.797 64.3325C132.93 63.8255 132.957 63.2963 132.876 62.7784C132.795 62.2604 132.608 61.7651 132.326 61.3237C132.224 61.187 132.093 61.0755 131.941 60.9979C131.79 60.9203 131.623 60.8785 131.453 60.8758H131.44Z",
    fill: "#F9F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M135.064 68.5951C134.861 68.5922 134.661 68.543 134.479 68.4513C134.298 68.3595 134.139 68.2275 134.016 68.0652C133.734 67.6406 133.543 67.1616 133.455 66.6588C133.368 66.156 133.385 65.6404 133.507 65.1448C133.827 63.2903 135.033 61.7891 136.195 61.7891C136.398 61.7945 136.598 61.8454 136.779 61.9382C136.961 62.0309 137.119 62.1632 137.243 62.3252C137.523 62.7499 137.712 63.2278 137.8 63.7291C137.887 64.2305 137.871 64.7446 137.752 65.2394C137.438 67.1002 136.232 68.5951 135.064 68.5951ZM136.176 61.9468C135.083 61.9468 133.953 63.3912 133.664 65.1763C133.551 65.6493 133.535 66.1403 133.617 66.6195C133.7 67.0988 133.878 67.5563 134.141 67.9643C134.253 68.1054 134.394 68.2206 134.555 68.3022C134.715 68.3838 134.891 68.4299 135.071 68.4374C136.163 68.4374 137.3 66.9992 137.583 65.2141C137.694 64.7415 137.71 64.251 137.629 63.7721C137.548 63.2931 137.372 62.8353 137.112 62.4261C137 62.2839 136.859 62.1675 136.699 62.0848C136.538 62.0021 136.362 61.955 136.182 61.9468H136.176Z",
    fill: "#F9F9F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9796 209.863C77.3516 209.863 76.7236 208.892 76.353 208.33C76.3406 208.312 76.334 208.29 76.334 208.267C76.334 208.245 76.3406 208.223 76.353 208.204C76.3665 208.186 76.3847 208.171 76.4057 208.162C76.4267 208.153 76.4498 208.15 76.4724 208.154C76.6733 208.198 78.4003 208.576 78.6201 209.169C78.6451 209.235 78.6519 209.305 78.6397 209.374C78.6275 209.443 78.5969 209.508 78.551 209.56C78.492 209.658 78.4077 209.738 78.307 209.791C78.2064 209.844 78.0932 209.869 77.9796 209.863ZM76.667 208.444C77.1506 209.175 77.6216 209.611 77.9607 209.63C78.036 209.63 78.1102 209.611 78.1762 209.575C78.2422 209.539 78.2977 209.486 78.3375 209.421C78.3587 209.399 78.373 209.371 78.3786 209.341C78.3842 209.311 78.3808 209.28 78.3689 209.251C78.2559 208.936 77.3578 208.62 76.667 208.444Z",
    fill: "url(#paint4_linear_8517_16365)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9491 208.444C76.759 208.445 76.5693 208.424 76.3839 208.381C76.365 208.375 76.3479 208.364 76.3337 208.35C76.3196 208.335 76.3088 208.318 76.3023 208.299C76.2899 208.262 76.2899 208.222 76.3023 208.186C76.3463 208.148 77.3071 207.195 78.0167 207.195H78.067C78.1549 207.201 78.2405 207.226 78.3184 207.267C78.3963 207.308 78.4647 207.365 78.5191 207.435C78.5832 207.502 78.6229 207.589 78.632 207.682C78.6411 207.774 78.6191 207.867 78.5694 207.946C78.3684 208.287 77.5646 208.444 76.9491 208.444ZM76.6665 208.198C77.2569 208.268 78.2114 208.097 78.4061 207.813C78.4375 207.769 78.4626 207.7 78.3684 207.58C78.3356 207.534 78.2923 207.496 78.2421 207.469C78.1919 207.443 78.1362 207.429 78.0795 207.429C77.5399 207.53 77.0456 207.799 76.6665 208.198Z",
    fill: "url(#paint5_linear_8517_16365)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M112.7 222.221C112.181 222.209 111.663 222.145 111.156 222.032C111.131 222.027 111.109 222.014 111.092 221.996C111.076 221.978 111.065 221.955 111.061 221.931C111.059 221.907 111.063 221.883 111.074 221.861C111.085 221.84 111.103 221.822 111.124 221.811C111.357 221.697 113.372 220.688 113.956 221.029C114.009 221.063 114.053 221.11 114.084 221.165C114.114 221.22 114.131 221.281 114.132 221.344C114.139 221.451 114.12 221.557 114.078 221.655C114.035 221.752 113.97 221.838 113.887 221.906C113.538 222.141 113.12 222.252 112.7 222.221ZM111.551 221.88C112.625 222.057 113.435 222.013 113.749 221.742C113.803 221.695 113.845 221.637 113.873 221.571C113.9 221.505 113.911 221.434 113.906 221.363C113.907 221.339 113.902 221.316 113.891 221.295C113.88 221.273 113.864 221.256 113.843 221.243C113.529 221.06 112.412 221.489 111.551 221.874V221.88Z",
    fill: "url(#paint6_linear_8517_16365)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M111.187 222.03H111.118C111.1 222.018 111.085 222.001 111.076 221.981C111.067 221.961 111.064 221.938 111.068 221.916C111.068 221.828 111.369 219.822 112.462 219.822H112.556C112.87 219.854 112.958 220.012 112.977 220.144C113.065 220.699 111.847 221.771 111.231 222.036L111.187 222.03ZM112.443 220.037C111.734 220.037 111.42 221.197 111.313 221.702C111.941 221.33 112.776 220.491 112.726 220.157C112.726 220.157 112.726 220.056 112.506 220.037H112.443Z",
    fill: "url(#paint7_linear_8517_16365)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 63.891L131.127 63.8027C131.127 63.8027 130.505 64.4461 130.141 63.891Z",
    fill: "#1A2E35"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M125.826 86.7562C117.662 83.6465 115.112 78.9914 115.307 78.0137L116.563 78.0894H116.808C117.121 78.0976 117.434 78.125 117.744 78.1714C118.322 78.2218 118.918 78.2849 119.521 78.3669L120.149 78.4552C123.146 78.8214 126.114 79.4011 129.029 80.1898C130.36 80.5809 130.8 80.7071 131.541 80.972L132.169 81.2117L132.433 81.3126C133.086 82.7255 132.941 85.6145 125.826 86.7562Z",
    fill: "#FD897B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M125.826 86.7562C117.662 83.6465 115.112 78.9914 115.307 78.0137L116.563 78.0894H116.808C118.466 80.4548 122.096 83.7222 125.795 84.17C128.771 83.5392 131.579 82.8201 131.553 80.972L132.181 81.2117L132.445 81.3126C133.086 82.7255 132.941 85.6145 125.826 86.7562Z",
    fill: "url(#paint8_linear_8517_16365)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M125.826 86.7562C117.662 83.6465 115.112 78.9914 115.307 78.0137L116.563 78.0894H116.808C118.466 80.4548 122.096 83.7222 125.795 84.17C128.771 83.5392 131.579 82.8201 131.553 80.972L132.181 81.2117L132.445 81.3126C133.086 82.7255 132.941 85.6145 125.826 86.7562Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M109.329 106.733L108.073 108.322C107.979 108.442 108.117 108.613 108.343 108.657L128.853 112.668C129.029 112.706 129.193 112.668 129.224 112.536L129.739 110.814C129.777 110.694 129.645 110.562 129.45 110.524L109.643 106.651C109.588 106.639 109.531 106.64 109.476 106.654C109.422 106.668 109.371 106.695 109.329 106.733Z",
    fill: "#1A2E35"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M111.559 109.475L111.031 109.375C110.924 109.375 110.855 109.286 110.874 109.217L111.565 106.984C111.565 106.915 111.691 106.883 111.791 106.902L112.325 107.003C112.432 107.003 112.501 107.097 112.482 107.161L111.791 109.4C111.767 109.437 111.73 109.465 111.688 109.479C111.646 109.493 111.6 109.491 111.559 109.475Z",
    fill: "url(#paint9_linear_8517_16365)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.559 109.475L111.031 109.375C110.924 109.375 110.855 109.286 110.874 109.217L111.565 106.984C111.565 106.915 111.691 106.883 111.791 106.902L112.325 107.003C112.432 107.003 112.501 107.097 112.482 107.161L111.791 109.4C111.767 109.437 111.73 109.465 111.688 109.479C111.646 109.493 111.6 109.491 111.559 109.475Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M112.952 85.539C112.714 87.0339 112.488 88.6929 112.324 90.2446C112.161 91.7963 112.017 93.3984 111.941 95.0132C111.899 95.808 111.874 96.6027 111.866 97.3975V99.7629C111.897 101.308 112.017 102.849 112.224 104.38C112.344 104.904 112.556 105.402 112.852 105.85C113.23 106.463 113.649 107.049 114.108 107.603C115.111 108.8 116.185 109.935 117.323 111.003C118.473 112.113 119.678 113.186 120.915 114.233C122.153 115.28 123.427 116.321 124.683 117.324L123.333 119.418C120.377 117.791 117.551 115.938 114.88 113.873C113.5 112.814 112.199 111.654 110.987 110.404C110.339 109.735 109.744 109.016 109.209 108.253C108.545 107.352 108.073 106.324 107.822 105.232L107.589 103.894C107.508 103.459 107.451 103.024 107.401 102.595C107.275 101.725 107.206 100.86 107.137 99.9963C107.006 98.2776 106.966 96.5532 107.018 94.8303C107.068 93.1209 107.162 91.4178 107.332 89.721C107.501 88.0242 107.715 86.359 108.054 84.6055L112.952 85.539Z",
    fill: "#FD897B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M108.782 79.2426C106.094 81.4251 106.735 87.9094 106.735 87.9094L115.778 90.8993C115.778 90.8993 115.363 83.4246 114.924 80.7375C114.384 77.5395 111.42 77.0917 108.782 79.2426Z",
    fill: "#1A2E35"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M123.578 116.919L127.667 115.393L127.039 119.297C127.039 119.297 124.074 120.369 122.555 118.994L123.578 116.919Z",
    fill: "#FD897B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M132.534 115.973V118.988L127.039 119.297L127.667 115.393L132.534 115.973Z",
    fill: "#FD897B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M127.352 112.567L126.824 112.466C126.717 112.466 126.648 112.378 126.667 112.309L127.358 110.076C127.358 110.006 127.484 109.975 127.59 109.994L128.118 110.095C128.225 110.095 128.294 110.189 128.275 110.252L127.584 112.492C127.565 112.555 127.484 112.592 127.352 112.567Z",
    fill: "url(#paint10_linear_8517_16365)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M127.352 112.567L126.824 112.466C126.717 112.466 126.648 112.378 126.667 112.309L127.358 110.076C127.358 110.006 127.484 109.975 127.59 109.994L128.118 110.095C128.225 110.095 128.294 110.189 128.275 110.252L127.584 112.492C127.565 112.555 127.484 112.592 127.352 112.567Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M119.459 111.015L118.925 110.914C118.819 110.914 118.75 110.825 118.775 110.756L119.465 108.523C119.465 108.454 119.585 108.422 119.692 108.441L120.225 108.542C120.326 108.542 120.401 108.636 120.376 108.7L119.685 110.939C119.666 111.015 119.566 111.046 119.459 111.015Z",
    fill: "url(#paint11_linear_8517_16365)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.459 111.015L118.925 110.914C118.819 110.914 118.75 110.825 118.775 110.756L119.465 108.523C119.465 108.454 119.585 108.422 119.692 108.441L120.225 108.542C120.326 108.542 120.401 108.636 120.376 108.7L119.685 110.939C119.666 111.015 119.566 111.046 119.459 111.015Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4612 147.796L112.017 219.212C112.763 220.835 114.118 222.095 115.787 222.718C117.455 223.341 119.301 223.275 120.922 222.536L126.09 220.164L245.768 165.129C247.385 164.382 248.641 163.023 249.262 161.348C249.884 159.673 249.82 157.819 249.084 156.191L220.315 93.1143L216.547 84.7818C215.798 83.1611 214.443 81.9027 212.775 81.2802C211.108 80.6578 209.263 80.7215 207.642 81.4577L82.7896 138.858C81.1731 139.605 79.9161 140.964 79.2927 142.638C78.6692 144.313 78.7298 146.166 79.4612 147.796Z",
    fill: "url(#paint12_linear_8517_16365)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.4612 147.796L112.017 219.212C112.763 220.835 114.118 222.095 115.787 222.718C117.455 223.341 119.301 223.275 120.922 222.536L126.09 220.164L245.768 165.129C247.385 164.382 248.641 163.023 249.262 161.348C249.884 159.673 249.82 157.819 249.084 156.191L220.315 93.1143L216.547 84.7818C215.798 83.1611 214.443 81.9027 212.775 81.2802C211.108 80.6578 209.263 80.7215 207.642 81.4577L82.7896 138.858C81.1731 139.605 79.9161 140.964 79.2927 142.638C78.6692 144.313 78.7298 146.166 79.4612 147.796Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M229.739 113.748L92.6758 176.777L108.717 211.969L245.78 148.939L229.739 113.748Z",
    fill: "url(#paint13_linear_8517_16365)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M229.739 113.748L92.6758 176.777L108.717 211.969L245.78 148.939L229.739 113.748Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M224.064 130.029L137.449 169.859L143.19 182.454L229.805 142.623L224.064 130.029Z",
    fill: "url(#paint14_linear_8517_16365)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M224.064 130.029L137.449 169.859L143.19 182.454L229.805 142.623L224.064 130.029Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M225.048 100.923L87.875 164.527L96.5111 183.317L233.684 119.713L225.048 100.923Z",
    fill: "url(#paint15_linear_8517_16365)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.048 100.923L87.875 164.527L96.5111 183.317L233.684 119.713L225.048 100.923Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0754 148.69L126.09 220.138L245.768 165.103C247.385 164.356 248.641 162.996 249.263 161.321C249.884 159.646 249.82 157.792 249.084 156.165L220.316 93.0879L101.868 139.942C100.215 140.602 98.8886 141.893 98.1781 143.531C97.4676 145.17 97.4307 147.024 98.0754 148.69Z",
    fill: "url(#paint16_linear_8517_16365)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M256.481 126.107L255.889 126.316L256.869 129.119L257.462 128.91L256.481 126.107Z",
    fill: "url(#paint17_linear_8517_16365)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.481 126.107L255.889 126.316L256.869 129.119L257.462 128.91L256.481 126.107Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M251.536 112.02L250.943 112.229L254.805 123.274L255.398 123.065L251.536 112.02Z",
    fill: "url(#paint18_linear_8517_16365)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M251.536 112.02L250.943 112.229L254.805 123.274L255.398 123.065L251.536 112.02Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M106.41 140.188L235.966 94.489C237.647 93.9015 239.491 94.0063 241.095 94.7805C242.699 95.5547 243.932 96.9354 244.526 98.6205L270.437 172.73C271.022 174.418 270.919 176.27 270.15 177.882C269.38 179.494 268.007 180.735 266.33 181.334L136.773 227.033C135.092 227.617 133.248 227.511 131.644 226.737C130.04 225.963 128.805 224.585 128.207 222.901L102.296 148.792C101.711 147.103 101.815 145.25 102.586 143.638C103.357 142.026 104.731 140.786 106.41 140.188Z",
    fill: "url(#paint19_linear_8517_16365)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.41 140.188L235.966 94.489C237.647 93.9015 239.491 94.0063 241.095 94.7805C242.699 95.5547 243.932 96.9354 244.526 98.6205L270.437 172.73C271.022 174.418 270.919 176.27 270.15 177.882C269.38 179.494 268.007 180.735 266.33 181.334L136.773 227.033C135.092 227.617 133.248 227.511 131.644 226.737C130.04 225.963 128.805 224.585 128.207 222.901L102.296 148.792C101.711 147.103 101.815 145.25 102.586 143.638C103.357 142.026 104.731 140.786 106.41 140.188Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M254.445 126.98L112.215 177.148L123.487 209.387L265.716 159.219L254.445 126.98Z",
    fill: "url(#paint20_linear_8517_16365)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M254.445 126.98L112.215 177.148L123.487 209.387L265.716 159.219L254.445 126.98Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M237.419 111.292L208.018 121.662L209.626 126.263L239.027 115.892L237.419 111.292Z",
    fill: "url(#paint21_linear_8517_16365)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M237.419 111.292L208.018 121.662L209.626 126.263L239.027 115.892L237.419 111.292Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M257.118 167.629L233.529 175.949L234.37 178.354L257.958 170.033L257.118 167.629Z",
    fill: "url(#paint22_linear_8517_16365)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M257.118 167.629L233.529 175.949L234.37 178.354L257.958 170.033L257.118 167.629Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M258.723 172.23L228.326 182.951L229.167 185.356L259.563 174.634L258.723 172.23Z",
    fill: "url(#paint23_linear_8517_16365)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M258.723 172.23L228.326 182.951L229.167 185.356L259.563 174.634L258.723 172.23Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M150.337 207.35L135.139 212.711L136.947 217.883L152.145 212.522L150.337 207.35Z",
    fill: "url(#paint24_linear_8517_16365)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M150.337 207.35L135.139 212.711L136.947 217.883L152.145 212.522L150.337 207.35Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M231.601 163.054L249.348 156.796C250.284 156.462 251.05 155.77 251.48 154.871C251.911 153.972 251.971 152.939 251.647 151.996C251.314 151.056 250.625 150.287 249.73 149.854C248.835 149.422 247.806 149.362 246.868 149.688L229.114 155.951C228.178 156.286 227.412 156.977 226.982 157.876C226.551 158.775 226.492 159.808 226.816 160.751C227.15 161.691 227.84 162.461 228.736 162.892C229.633 163.323 230.662 163.381 231.601 163.054Z",
    fill: "url(#paint25_linear_8517_16365)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M201.198 173.777L218.952 167.514C219.88 167.178 220.64 166.489 221.069 165.596C221.498 164.704 221.56 163.677 221.244 162.739C220.91 161.8 220.22 161.032 219.325 160.601C218.431 160.17 217.403 160.111 216.465 160.436L198.718 166.7C197.782 167.034 197.016 167.726 196.585 168.625C196.155 169.524 196.095 170.557 196.419 171.5C196.758 172.434 197.45 173.196 198.344 173.622C199.238 174.048 200.263 174.104 201.198 173.777Z",
    fill: "url(#paint26_linear_8517_16365)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M170.816 184.5L188.569 178.236C189.496 177.898 190.253 177.208 190.679 176.316C191.105 175.423 191.166 174.398 190.849 173.461C190.515 172.523 189.825 171.754 188.931 171.323C188.036 170.892 187.008 170.833 186.07 171.159L168.304 177.397C167.369 177.733 166.604 178.425 166.175 179.324C165.746 180.223 165.687 181.255 166.012 182.197C166.346 183.142 167.039 183.915 167.94 184.346C168.84 184.778 169.875 184.833 170.816 184.5Z",
    fill: "url(#paint27_linear_8517_16365)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M140.403 195.222L158.157 188.959C159.086 188.624 159.848 187.936 160.278 187.043C160.708 186.15 160.772 185.124 160.455 184.184C160.121 183.245 159.432 182.477 158.537 182.046C157.642 181.615 156.614 181.556 155.676 181.882L137.923 188.145C136.987 188.48 136.221 189.171 135.79 190.07C135.36 190.969 135.3 192.002 135.624 192.945C135.963 193.879 136.655 194.642 137.549 195.068C138.443 195.494 139.468 195.549 140.403 195.222Z",
    fill: "url(#paint28_linear_8517_16365)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M231.601 163.054L249.348 156.796C250.284 156.462 251.05 155.77 251.48 154.871C251.911 153.972 251.971 152.939 251.647 151.996C251.314 151.056 250.625 150.287 249.73 149.854C248.835 149.422 247.806 149.362 246.868 149.688L229.114 155.951C228.178 156.286 227.412 156.977 226.982 157.876C226.551 158.775 226.492 159.808 226.816 160.751C227.15 161.691 227.84 162.461 228.736 162.892C229.633 163.323 230.662 163.381 231.601 163.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M201.2 173.777L218.954 167.514C219.882 167.178 220.642 166.489 221.071 165.596C221.5 164.704 221.562 163.677 221.246 162.739C220.912 161.8 220.222 161.032 219.327 160.601C218.433 160.17 217.405 160.111 216.467 160.436L198.719 166.7C197.784 167.034 197.018 167.726 196.587 168.625C196.157 169.524 196.097 170.557 196.421 171.5C196.76 172.434 197.452 173.196 198.346 173.622C199.24 174.048 200.265 174.104 201.2 173.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M170.818 184.5L188.571 178.236C189.497 177.898 190.255 177.208 190.681 176.316C191.107 175.423 191.168 174.398 190.851 173.461C190.517 172.523 189.827 171.754 188.933 171.323C188.038 170.892 187.01 170.833 186.072 171.159L168.306 177.397C167.371 177.733 166.606 178.425 166.177 179.324C165.748 180.223 165.689 181.255 166.013 182.197C166.347 183.142 167.041 183.915 167.942 184.346C168.842 184.778 169.877 184.833 170.818 184.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M140.403 195.222L158.157 188.959C159.086 188.624 159.848 187.936 160.278 187.043C160.708 186.15 160.772 185.124 160.455 184.184C160.121 183.245 159.432 182.477 158.537 182.046C157.642 181.615 156.614 181.556 155.676 181.882L137.923 188.145C136.987 188.48 136.221 189.171 135.79 190.07C135.36 190.969 135.3 192.002 135.624 192.945C135.963 193.879 136.655 194.642 137.549 195.068C138.443 195.494 139.468 195.549 140.403 195.222Z",
    fill: "white"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M240.826 128.843L225.029 134.415C223.687 134.888 222.982 136.364 223.453 137.712L226.745 147.127C227.216 148.474 228.685 149.183 230.027 148.71L245.824 143.138C247.165 142.665 247.871 141.189 247.4 139.841L244.108 130.426C243.637 129.078 242.167 128.369 240.826 128.843Z",
    fill: "url(#paint29_linear_8517_16365)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.826 128.843L225.029 134.415C223.687 134.888 222.982 136.364 223.453 137.712L226.745 147.127C227.216 148.474 228.685 149.183 230.027 148.71L245.824 143.138C247.165 142.665 247.871 141.189 247.4 139.841L244.108 130.426C243.637 129.078 242.167 128.369 240.826 128.843Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M145.496 146.339C145.102 145.208 144.49 144.166 143.695 143.273C142.9 142.38 141.937 141.653 140.862 141.134C139.787 140.615 138.621 140.314 137.43 140.248C136.239 140.182 135.047 140.353 133.922 140.75L121.161 145.563L120.998 145.607L120.621 145.765L120.388 145.853C118.328 146.787 116.705 148.483 115.857 150.588C115.009 152.693 115.001 155.045 115.834 157.156C116.667 159.267 118.278 160.975 120.332 161.924C122.386 162.873 124.725 162.991 126.863 162.253L138.946 158.216C139.294 158.138 139.638 158.041 139.976 157.926C140.226 157.838 140.471 157.737 140.711 157.623C142.764 156.678 144.393 154.998 145.278 152.911C146.163 150.824 146.241 148.48 145.496 146.339Z",
    fill: "url(#paint30_linear_8517_16365)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M145.496 146.339C145.102 145.208 144.49 144.166 143.695 143.273C142.9 142.38 141.937 141.653 140.862 141.134C139.787 140.615 138.621 140.314 137.43 140.248C136.239 140.182 135.047 140.353 133.922 140.75L121.161 145.563L120.998 145.607L120.621 145.765L120.388 145.853C118.328 146.787 116.705 148.483 115.857 150.588C115.009 152.693 115.001 155.045 115.834 157.156C116.667 159.267 118.278 160.975 120.332 161.924C122.386 162.873 124.725 162.991 126.863 162.253L138.946 158.216C139.294 158.138 139.638 158.041 139.976 157.926C140.226 157.838 140.471 157.737 140.711 157.623C142.764 156.678 144.393 154.998 145.278 152.911C146.163 150.824 146.241 148.48 145.496 146.339Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8517_16365)"
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M228.858 133.431C227.187 151.318 211.187 165.447 193.067 164.989C174.884 164.53 161.461 149.567 163.142 131.57C164.823 113.572 180.964 99.4433 199.137 100.017C217.247 100.586 230.529 115.545 228.858 133.431Z",
    fill: "url(#paint31_linear_8517_16365)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M196.427 153.057C184.981 153.057 175.668 143.835 175.668 132.5C175.668 121.165 184.981 111.943 196.427 111.943C207.874 111.943 217.187 121.165 217.187 132.5C217.187 143.835 207.874 153.057 196.427 153.057ZM196.427 119.504C189.191 119.504 183.304 125.334 183.304 132.5C183.304 139.666 189.191 145.496 196.427 145.496C203.664 145.496 209.551 139.666 209.551 132.5C209.551 125.334 203.664 119.504 196.427 119.504Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M186.825 146.703C186.071 146.702 185.335 146.48 184.708 146.066C184.081 145.651 183.593 145.062 183.304 144.372C183.015 143.683 182.938 142.924 183.084 142.192C183.229 141.46 183.59 140.786 184.121 140.257L204.849 119.613C205.202 119.261 205.622 118.981 206.085 118.79C206.548 118.599 207.044 118.5 207.545 118.498C208.046 118.497 208.543 118.593 209.007 118.782C209.471 118.97 209.893 119.247 210.248 119.597C210.604 119.948 210.886 120.363 211.079 120.822C211.273 121.28 211.373 121.771 211.374 122.268C211.376 122.764 211.279 123.256 211.088 123.715C210.898 124.174 210.618 124.592 210.264 124.944L189.537 145.588C189.182 145.942 188.759 146.223 188.294 146.415C187.828 146.606 187.329 146.704 186.825 146.703Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M193.289 156.375C190.908 152.204 195.725 148.772 195.922 140.453C196.22 127.819 185.406 123.24 186.856 112.584C187.259 109.62 188.746 105.189 194.325 100.211C178.197 102.004 164.673 115.181 163.142 131.571C161.461 149.568 174.884 164.531 193.067 164.99C199.265 165.147 205.216 163.596 210.429 160.772C203.643 161.224 195.81 160.79 193.289 156.375Z",
    fill: "url(#paint32_linear_8517_16365)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8517_16365",
    x1: 131.328,
    y1: 72.8634,
    x2: 134.068,
    y2: 74.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8517_16365",
    x1: 114.689,
    y1: 70.1205,
    x2: 117.575,
    y2: 71.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8517_16365",
    x1: 105.504,
    y1: 111.634,
    x2: 142.113,
    y2: 116.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8517_16365",
    x1: 75.3164,
    y1: 110.315,
    x2: 146.786,
    y2: 131.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8517_16365",
    x1: 76.334,
    y1: 208.195,
    x2: 78.6165,
    y2: 210.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8517_16365",
    x1: 76.293,
    y1: 207.227,
    x2: 77.9963,
    y2: 209.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8517_16365",
    x1: 111.061,
    y1: 220.991,
    x2: 112.694,
    y2: 223.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8517_16365",
    x1: 111.066,
    y1: 219.878,
    x2: 113.514,
    y2: 221.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8517_16365",
    x1: 115.297,
    y1: 78.2322,
    x2: 127.133,
    y2: 92.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8517_16365",
    x1: 110.871,
    y1: 106.961,
    x2: 113.159,
    y2: 107.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8517_16365",
    x1: 126.664,
    y1: 110.053,
    x2: 128.951,
    y2: 110.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8517_16365",
    x1: 118.77,
    y1: 108.5,
    x2: 121.055,
    y2: 109.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8517_16365",
    x1: 78.8652,
    y1: 84.4126,
    x2: 262.376,
    y2: 213.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8517_16365",
    x1: 93.0768,
    y1: 177.657,
    x2: 165.456,
    y2: 242.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8517_16365",
    x1: 137.593,
    y1: 170.174,
    x2: 160.536,
    y2: 198.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8517_16365",
    x1: 88.0909,
    y1: 164.997,
    x2: 122.033,
    y2: 208.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8517_16365",
    x1: 97.6172,
    y1: 96.2641,
    x2: 261.309,
    y2: 211.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8517_16365",
    x1: 255.913,
    y1: 126.386,
    x2: 256.892,
    y2: 126.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8517_16365",
    x1: 251.04,
    y1: 112.505,
    x2: 252.002,
    y2: 112.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8517_16365",
    x1: 101.922,
    y1: 97.4456,
    x2: 276.759,
    y2: 227.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8517_16365",
    x1: 112.497,
    y1: 177.954,
    x2: 169.162,
    y2: 244.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8517_16365",
    x1: 208.058,
    y1: 121.777,
    x2: 215.332,
    y2: 132.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8517_16365",
    x1: 233.55,
    y1: 176.009,
    x2: 236.911,
    y2: 182.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8517_16365",
    x1: 228.347,
    y1: 183.011,
    x2: 231.497,
    y2: 189.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8517_16365",
    x1: 135.184,
    y1: 212.84,
    x2: 145.046,
    y2: 221.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8517_16365",
    x1: 226.609,
    y1: 149.825,
    x2: 245.443,
    y2: 170.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8517_16365",
    x1: 196.213,
    y1: 160.572,
    x2: 215.013,
    y2: 180.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8517_16365",
    x1: 165.805,
    y1: 171.295,
    x2: 184.611,
    y2: 191.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8517_16365",
    x1: 135.418,
    y1: 182.018,
    x2: 154.217,
    y2: 202.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8517_16365",
    x1: 222.725,
    y1: 135.629,
    x2: 247.753,
    y2: 145.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8517_16365",
    x1: 115.215,
    y1: 140.797,
    x2: 145.305,
    y2: 164.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8517_16365",
    x1: 167.736,
    y1: 84.3303,
    x2: 230.554,
    y2: 90.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8517_16365",
    x1: 166.403,
    y1: 84.5919,
    x2: 211.766,
    y2: 87.8977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8517_16365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 65,
    fill: "white",
    transform: "translate(163 100)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRenewalV2);
export default __webpack_public_path__ + "static/media/cancel-renewal-v2.7e8f6f1c029ceea5daf1e53cdb1ca2e0.svg";
export { ForwardRef as ReactComponent };